import React from 'react'
import { slugify } from '../../helpers/StringHelpers'

export const InlineSectionHeading = children => {
  const id = slugify(children)
  return `<h2 class="text-2xl font-bold text-center my-5 uppercase" id="${id}">${children}</h2>`
}

const SectionHeading = ({ children }) => {
  return <h2 className="text-2xl font-bold text-center my-5 uppercase">{children}</h2>
}

export default SectionHeading
